module.exports = __webpack_public_path__ + "assets/img/57d2f246e99751dc1d6966719f77d75b.png";